var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionsTorchOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.081 4.735h1.905V.925H9.081v3.81zm-3.088 1.28L4.646 7.36 1.953 4.668 3.299 3.32l2.694 2.694zM16.768 3.32l1.347 1.348-2.694 2.693-1.347-1.346 2.694-2.694zM0 11.825V9.92h3.3v1.905H0zM16.715 9.92v1.905H20V9.92h-3.285z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.922 16.342a5.238 5.238 0 1 1 6.667 0v3.102H6.921v-3.102zm6.666-4.041c0 1.33-.778 2.477-1.904 3.012v2.226H8.826v-2.226a3.334 3.334 0 1 1 4.762-3.012z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsTorchOn);
export default __webpack_public_path__ + "static/media/actions-torch-on.1b1a4c0d5ffedc8d78387aace1f658dd.svg";
export { ForwardRef as ReactComponent };